<template>

  <el-dialog
    class="schedule-form-modal"
    :title="modalTitle"
    :visible.sync="formModalOpened"
    :before-close="handleClose"
  >
    <el-form
      ref="scheduleForm"
      :model="formData"
      :rules="rules"
      label-position="top"
      v-loading="loading"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('modules.schedule.fields.startTime.label')" prop="start_time">
            <el-time-picker v-model.lazy.trim="formData.start_time" value-format="hh:mm A" format="hh:mm A" :picker-options="{format:'hh:mm A'}" :placeholder="$t('modules.schedule.fields.startTime.placeholder')"></el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('modules.schedule.fields.workLength.label')" prop="work_length">
            <el-input type="number" v-model.lazy.trim="formData.work_length" step="1" min="0" max="24" :placeholder="$t('modules.schedule.fields.workLength.placeholder')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('modules.schedule.fields.breakLength.label')" prop="break_length">
            <el-input type="number" v-model.lazy.trim="formData.break_length" step="5" min="0" max="480" :placeholder="$t('modules.schedule.fields.breakLength.placeholder')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="submitForm()" :loading="loading">Save</el-button>
    </span>

  </el-dialog>
</template>

<script>
  import Vue from 'vue';
  import validations from '@/utils/validations';
  import { mapGetters, mapActions } from 'vuex';

  import formPopulator from '@/mixins/form_populator';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'ScheduleFormModal',
    mixins: [formPopulator],
    data() {
      return {
        timePickerOptions: {
          start: '00:00',
          end: '23:45',
          step: '00:15',
        },
        rules: {
          start_time: [
            { ...validations.required },
          ],
          work_length: [
            { ...validations.required },
          ],
        },
        formData: {
          start_time: '09:00 AM',
          work_length: '8',
          break_length: '30',
        },
      };
    },
    computed: {
      ...mapGetters('entities/schedules', ['creating', 'isUpdating', 'scheduleFromContext', 'formModalAdditionalContext']),
      ...mapGetters('entities/users', ['userFromContext']),

      formModalOpened: {
        get() {
          return this.$store.getters['entities/schedules/formModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.closeFormModal();
          }
        },
      },

      modalTitle() {
        return this.scheduleFromContext ? 'Edit Schedule' : 'Add New Schedule';
      },

      loading() {
        return (this.scheduleFromContext) ? this.isUpdating(this.scheduleFromContext.id) : this.creating;
      },
    },
    methods: {
      ...mapActions('entities/schedules', ['createSchedule', 'updateSchedule', 'closeFormModal', 'setContext']),

      submitForm() {
        this.$refs.scheduleForm.validate((valid) => {
          if (valid) {
            if (this.scheduleFromContext) {
              this.updateSchedule({ id: this.scheduleFromContext.id, data: { ...this.formModalAdditionalContext, ...this.formData } })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Schedule has been edited successfully.');
                    this.handleClose();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            } else {
              this.createSchedule({ user_id: this.userFromContext.id, day: this.formModalAdditionalContext, ...this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Schedule has been saved.');
                    this.handleClose();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            }
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));
            return false;
          }
          return true;
        });
      },

      clearForm() {
        this.$refs.scheduleForm.resetFields();
      },

      handleClose() {
        this.closeFormModal();
        this.setContext(null);
      },
    },

    watch: {
      scheduleFromContext: {
        handler(newObject) {
          if (newObject) {
            this.formData.start_time = Vue.filter('formatTimeNoTZ')(newObject.start_time, 'hh:mm A');
            this.formData.work_length = newObject.work_length;
            this.formData.break_length = newObject.break_length;
          } else {
            // this.clearForm();
          }
        },
        deep: true,
      },
    },
  };
</script>
<style lang="scss">
  .el-date-editor.el-input{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/schedule/ScheduleFormModal.vue